import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("What is Monarch?")
const _hoisted_2 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Highlights")
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "Some cool things you can do on this website.", -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Quickly and easily browse nodes. Filter by category and taxon. See your recent and frequent searches. ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Easily search our knowledge graph for multiple nodes from free text. Download the results or send them to the phenotype explorer tool for analysis. ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Compare a set of phenotypes to another set of phenotypes, or to all genes/diseases of a species. See a rich comparison of the overlap between the two sets. ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" See rich details about each node. Traverse between nodes via associations between them, and view the evidence for those associations. ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("News")
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, "Latest posts about Monarch.", -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Loading posts")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Error loading posts")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Follow")
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", null, "Be the first to know when we have major updates or other fun news.", -1)

import { onMounted, ref } from "vue";
import AppTabs from "@/components/AppTabs.vue";
import AppHighlight from "@/components/AppHighlight.vue";
import AppPost from "@/components/AppPost.vue";
import AppTile from "@/components/AppTile.vue";
import tabs from "./explore/tabs.json";
import NodeSearch from "./explore/NodeSearch.vue";
import { useQuery } from "@/util/composables";
import { getBlogPosts } from "@/api/blog";

/** selected tab state */

export default /*#__PURE__*/_defineComponent({
  __name: 'PageHome',
  setup(__props) {

const tab = ref(tabs[0].id);

const {
  query: getPosts,
  data: blogPosts,
  isLoading,
  isError,
} = useQuery(async function () {
  return await getBlogPosts();
}, []);

onMounted(getPosts);

return (_ctx: any,_cache: any) => {
  const _component_AppSection = _resolveComponent("AppSection")!
  const _component_AppHeading = _resolveComponent("AppHeading")!
  const _component_AppFlex = _resolveComponent("AppFlex")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_AppStatus = _resolveComponent("AppStatus")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_AppSection, { design: "fill" }, {
      default: _withCtx(() => [
        _createVNode(AppTabs, {
          modelValue: tab.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tab).value = $event)),
          name: "Explore Mode",
          tabs: _unref(tabs),
          route: "Explore"
        }, null, 8, ["modelValue", "tabs"]),
        _createVNode(NodeSearch)
      ]),
      _: 1
    }),
    _createVNode(_component_AppSection, null, {
      default: _withCtx(() => [
        _createVNode(_component_AppHeading, null, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }),
        _createVNode(_component_AppFlex, {
          gap: "big",
          vAlign: "top"
        }, {
          default: _withCtx(() => [
            _createVNode(AppTile, {
              icon: "knowledge-graph",
              title: "An extensive, cross-species, semantic knowledge graph"
            }),
            _createVNode(AppTile, {
              icon: "phenotype-search",
              title: "A website for quick and easy exploration of the graph"
            }),
            _createVNode(AppTile, {
              icon: "toolbox",
              title: "Powerful API and ecosystem of related tools"
            })
          ]),
          _: 1
        }),
        _hoisted_2,
        _createVNode(_component_AppFlex, null, {
          default: _withCtx(() => [
            _createVNode(AppTile, {
              icon: "category-gene",
              design: "small",
              title: `~${(1000000).toLocaleString()}`,
              subtitle: "genes"
            }, null, 8, ["title"]),
            _createVNode(AppTile, {
              icon: "category-disease",
              design: "small",
              title: `~${(25000).toLocaleString()}`,
              subtitle: "diseases"
            }, null, 8, ["title"]),
            _createVNode(AppTile, {
              icon: "category-phenotype",
              design: "small",
              title: `~${(70000).toLocaleString()}`,
              subtitle: "phenotypes"
            }, null, 8, ["title"]),
            _createVNode(AppTile, {
              icon: "category-variant",
              design: "small",
              title: `~${(3000000).toLocaleString()}`,
              subtitle: "variants"
            }, null, 8, ["title"]),
            _createVNode(AppTile, {
              icon: "category-genotype",
              design: "small",
              title: `~${(200000).toLocaleString()}`,
              subtitle: "genotypes"
            }, null, 8, ["title"]),
            _createVNode(AppTile, {
              icon: "category-anatomy",
              design: "small",
              title: `~${(100000).toLocaleString()}`,
              subtitle: "anatomies"
            }, null, 8, ["title"]),
            _createVNode(AppTile, {
              icon: "category-publication",
              design: "small",
              title: `~${(50000).toLocaleString()}`,
              subtitle: "publications"
            }, null, 8, ["title"]),
            _createVNode(AppTile, {
              icon: "category-unknown",
              design: "small",
              title: `~${(5000000).toLocaleString()}`,
              subtitle: "total nodes"
            }, null, 8, ["title"])
          ]),
          _: 1
        }),
        _createVNode(_component_AppButton, {
          to: "/about",
          text: "Learn more",
          icon: "arrow-right"
        })
      ]),
      _: 1
    }),
    _createVNode(_component_AppSection, null, {
      default: _withCtx(() => [
        _createVNode(_component_AppHeading, null, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }),
        _hoisted_4,
        _createVNode(AppHighlight, {
          src: require('@/assets/demos/node-search.mp4')
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["src"]),
        _createVNode(AppHighlight, {
          src: require('@/assets/demos/text-annotator.mp4')
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }, 8, ["src"]),
        _createVNode(AppHighlight, {
          src: require('@/assets/demos/phenotype-explorer.mp4')
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }, 8, ["src"]),
        _createVNode(AppHighlight, {
          src: require('@/assets/demos/node-page.mp4')
        }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        }, 8, ["src"])
      ]),
      _: 1
    }),
    _createVNode(_component_AppSection, null, {
      default: _withCtx(() => [
        _createVNode(_component_AppHeading, null, {
          default: _withCtx(() => [
            _hoisted_9
          ]),
          _: 1
        }),
        _hoisted_10,
        (_unref(isLoading))
          ? (_openBlock(), _createBlock(_component_AppStatus, {
              key: 0,
              code: "loading"
            }, {
              default: _withCtx(() => [
                _hoisted_11
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(isError))
          ? (_openBlock(), _createBlock(_component_AppStatus, {
              key: 1,
              code: "error"
            }, {
              default: _withCtx(() => [
                _hoisted_12
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(blogPosts).length)
          ? (_openBlock(), _createBlock(_component_AppFlex, {
              key: 2,
              direction: "col",
              gap: "big"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(blogPosts).slice(0, 5), (item, index) => {
                  return (_openBlock(), _createBlock(AppPost, {
                    key: index,
                    class: "blog-post",
                    image: item.thumbnail,
                    date: item.date,
                    link: item.link,
                    title: item.title,
                    description: item.description
                  }, null, 8, ["image", "date", "link", "title", "description"]))
                }), 128))
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_AppButton, {
          to: "https://monarchinit.medium.com/",
          text: "More on Medium",
          icon: "medium"
        })
      ]),
      _: 1
    }),
    _createVNode(_component_AppSection, null, {
      default: _withCtx(() => [
        _createVNode(_component_AppHeading, null, {
          default: _withCtx(() => [
            _hoisted_13
          ]),
          _: 1
        }),
        _hoisted_14,
        _createVNode(_component_AppFlex, null, {
          default: _withCtx(() => [
            _createVNode(AppTile, {
              to: "https://medium.com/@MonarchInit",
              icon: "medium",
              title: "Medium",
              subtitle: "Blog posts and major updates",
              design: "small"
            }),
            _createVNode(AppTile, {
              to: "https://github.com/monarch-initiative",
              icon: "github",
              title: "GitHub",
              subtitle: "Source code and releases",
              design: "small"
            }),
            _createVNode(AppTile, {
              to: "https://twitter.com/MonarchInit",
              icon: "twitter",
              title: "Twitter",
              subtitle: "Quick updates and musings",
              design: "small"
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})